/**
 * GanttStats Component - Statistics cards for Gantt chart
 */
import React from 'react';
import { STATUS_CONFIG } from '../../constants/status';

interface GanttStatsProps {
  stats: Record<string, number>;
}

export const GanttStats: React.FC<GanttStatsProps> = ({ stats }) => {
  // Lighter/Clearer Gradient Map
  const gradientMap: Record<string, string> = {
    'gray': 'from-gray-400 to-gray-500',
    'blue': 'from-blue-400 to-blue-500',
    'cyan': 'from-cyan-400 to-cyan-500',
    'purple': 'from-purple-400 to-purple-500',
    'green': 'from-green-400 to-green-500',
    'red': 'from-red-400 to-red-500',
    'slate': 'from-slate-400 to-slate-500',
    'teal': 'from-teal-400 to-teal-500',
    'emerald': 'from-emerald-400 to-emerald-500',
    'yellow': 'from-yellow-400 to-yellow-500',
    'orange': 'from-orange-400 to-orange-500',
    'indigo': 'from-indigo-400 to-indigo-500',
  };

  const getGradient = (colorClass: string): string => {
    const colorName = colorClass.split('-')[1];
    return gradientMap[colorName] || 'from-gray-400 to-gray-500';
  };

  return (
    <div className="grid grid-cols-5 lg:grid-cols-10 gap-2 mb-4">
      {/* Total Card */}
      <div className="bg-gradient-to-br from-slate-400 to-slate-500 rounded-lg px-1.5 py-1.5 text-white flex flex-col items-center justify-center text-center shadow-sm min-h-[50px]">
        <div className="text-[9px] font-semibold uppercase tracking-wider opacity-90">Total</div>
        <div className="text-base font-bold leading-tight">{stats.total}</div>
      </div>

      {/* Status Cards */}
      {Object.entries(STATUS_CONFIG).map(([key, config]) => {
        const colorClass = config.color.split(' ')[0];
        const gradient = getGradient(colorClass);

        return (
          <div key={key} className={`bg-gradient-to-br ${gradient} rounded-lg px-1.5 py-1.5 text-white flex flex-col items-center justify-center text-center shadow-sm min-h-[50px]`}>
            <div className="text-[9px] font-semibold uppercase tracking-wider opacity-90 truncate w-full leading-tight" title={config.label}>
              {config.label}
            </div>
            <div className="text-base font-bold leading-tight">{stats[key] || 0}</div>
          </div>
        );
      })}

      {/* Auditores Card */}
      <div className="bg-gradient-to-br from-violet-400 to-violet-500 rounded-lg px-1.5 py-1.5 text-white flex flex-col items-center justify-center text-center shadow-sm min-h-[50px]">
        <div className="text-[9px] font-semibold uppercase tracking-wider opacity-90">Auditores</div>
        <div className="text-base font-bold leading-tight">{stats.auditores}</div>
      </div>
    </div>
  );
};
